/** @format **/

import React, { FunctionComponent, useEffect, useState } from 'react';
import SelectFromRest from '../Form/SelectFromRest';
import { makeStyles } from '@material-ui/core';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import I18n from '../../core/i18n';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { useDispatch } from 'react-redux';

const useStyle = makeStyles(adescomStyle);

export interface SimpleSelectElements {
    name: string;
    value: number | string;
}

export type SimpleSelectType = {
    label: string;
    noValueLabel?: string;
    required: boolean;
    elements: Array<SimpleSelectElements>;
    selectedValue?: number | string | null;
    markAsError?: boolean;
    dispatchName: string;
    processValueForOutput?: (value: number) => string | null;
    fieldName?: string;
    callback?(event: React.ChangeEvent<HTMLSelectElement>): void;
    extraFieldName?: string;
    disabled?: boolean;
};

export const SimpleSelect: FunctionComponent<SimpleSelectType> = ({
    markAsError,
    noValueLabel,
    label,
    required,
    elements,
    selectedValue,
    dispatchName,
    processValueForOutput,
    fieldName,
    callback,
    extraFieldName,
    disabled,
}): React.ReactElement => {
    const classes = useStyle();
    const dispatch = useDispatch();
    const [currentValue, setCurrentValue] = useState<string | number | null | undefined>(selectedValue ?? null);

    useEffect(() => {
        setCurrentValue(selectedValue);
    }, [selectedValue]);

    const handleSelectFunc = (e: { target: { value: string; name: string | number } }, stateName: string, require: boolean): void => {
        const targetObject = e.target;
        setCurrentValue(targetObject.value);

        const dispatchData = {
            type: dispatchName,
            selectedValue: targetObject.value,
            valueChange: selectedValue !== targetObject.value,
            fieldName: fieldName,
            extraFieldName: extraFieldName,
        };

        if (processValueForOutput) {
            const processedValue = processValueForOutput(parseInt(targetObject.value));
            if (processedValue) {
                dispatchData.selectedValue = processedValue;
            }
        }

        dispatch(dispatchData);
    };

    let stateObjectState = null;
    if (markAsError) {
        stateObjectState = FormGeneralHelper.ERROR;
    }

    const selectedValueRest = { 'hydra:member': elements };

    return (
        <SelectFromRest
            disabled={disabled}
            classes={classes}
            callback={callback ?? handleSelectFunc}
            required={required}
            restElements={selectedValueRest}
            stateName={callback && fieldName ? fieldName : 'name'}
            stateObjectState={stateObjectState}
            selectedValue={currentValue}
            propKey="value"
            propValue="name"
            addEmpty={false}
            displayEmpty={false}
            emptyLabel={noValueLabel ? I18n.t(noValueLabel).toString() : null}
            label={I18n.t(label)}
        />
    );
};
